import { Text } from 'braid-design-system';
import { useTranslations } from '@vocab/react';
import translations from '../.vocab';

export const Free = ({ name }: { name: string }) => {
  const { t } = useTranslations(translations);
  return (
    <Text size="standard" weight="strong" align="right" id={`${name}_free`}>
      {t('Free')}
    </Text>
  );
};
